export const checkDisabled = (payment) => {
	return (
		payment?.status !== 'COMPLETED' ||
		!payment?.status_complated_date ||
		payment?.status_refunded_date
	);
};
